import { createContext, Dispatch } from 'react';
import {
  ChannelTypeUnitsAndPercentageModel,
  ChannelGroupModel,
  DataOptionsType,
  GraphUnitsModel,
  IntervalOptionsType,
} from '@shared/models';

interface State {
  interval: IntervalOptionsType;
  dataType: DataOptionsType;
  units: GraphUnitsModel[];
  showAlarmBoundariesAsPercentage: boolean | null;
  channelTypeUnitsAndPercentage: ChannelTypeUnitsAndPercentageModel;
  channelGroups: ChannelGroupModel[];
  includeCalibrationHistory: boolean;
}

export const GraphReducerDefaultValues: State = {
  interval: IntervalOptionsType.Auto,
  dataType: DataOptionsType.Primary,
  units: [],
  showAlarmBoundariesAsPercentage: null,
  channelTypeUnitsAndPercentage: {
    channelTypeUnitOptions: [],
    canShowPercentage: false,
  },
  channelGroups: [],
  includeCalibrationHistory: false,
};

type Action =
  | {
      type: 'SetInterval';
      payload: IntervalOptionsType;
    }
  | {
      type: 'SetDataType';
      payload: DataOptionsType;
    }
  | {
      type: 'SetUnits';
      payload: GraphUnitsModel[];
    }
  | {
      type: 'SetChannelTypeUnitsAndPercentage';
      payload: ChannelTypeUnitsAndPercentageModel;
    }
  | {
      type: 'SetShowAsPercentage';
      payload: boolean;
    }
  | {
      type: 'SetChannelGroups';
      payload: ChannelGroupModel[];
    }
  | {
      type: 'SetIncludeCalibrationHistory';
      payload: boolean;
    };

export const graphReducer = (state: State, action: Action): State => {
  const { type, payload } = action;
  switch (type) {
    case 'SetInterval':
      return { ...state, interval: payload };
    case 'SetDataType':
      return { ...state, dataType: payload };
    case 'SetUnits':
      return { ...state, units: payload };
    case 'SetChannelGroups':
      return { ...state, channelGroups: payload };
    case 'SetShowAsPercentage':
      return { ...state, showAlarmBoundariesAsPercentage: payload };
    case 'SetChannelTypeUnitsAndPercentage':
      return {
        ...state,
        channelTypeUnitsAndPercentage: payload,
      };
    case 'SetIncludeCalibrationHistory':
      return { ...state, includeCalibrationHistory: payload };
    default:
      return state;
  }
};

export const GraphContext = createContext<{
  state?: State;
  dispatch?: Dispatch<Action>;
}>({});
